import React from 'react'

function NotFound() {
    return (
        <>
            <div className='not-found-section top'>
                <div className='container top'>
                    <div class="sec-title top">
                        <h2 className='text-white'>Something Went Wrong</h2>
                        <div class="sub-heading text-white">The page you were looking for was not found at CYBER FORTIFY TECHNOLOGES.</div>
                    </div>
                </div>

                <img src={require('../assets/images/404.webp')} />
            </div>
        </>
    )
}

export default NotFound